/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

export function MessagesCard(props) {



  return (
    <>
      <div className="card card-custom gutter-b h-sm-600px">
        <div className="card-body">
          <div className="d-flex">{props.children}</div>
        </div>
      </div>
    </>
  );
}
